import { render, staticRenderFns } from "./SubmitFileChangeBtn.vue?vue&type=template&id=78fccdca&scoped=true&"
import script from "./SubmitFileChangeBtn.vue?vue&type=script&lang=js&"
export * from "./SubmitFileChangeBtn.vue?vue&type=script&lang=js&"
import style0 from "./SubmitFileChangeBtn.vue?vue&type=style&index=0&id=78fccdca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fccdca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78fccdca')) {
      api.createRecord('78fccdca', component.options)
    } else {
      api.reload('78fccdca', component.options)
    }
    module.hot.accept("./SubmitFileChangeBtn.vue?vue&type=template&id=78fccdca&scoped=true&", function () {
      api.rerender('78fccdca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Packages/FIlesPreviewer/components/Tools/SubmitFileChangeBtn.vue"
export default component.exports